import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 项目概况
export function profile(req) {
  return request({
    url: apiConfig.projectStatistics.api.profile.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}

export function searchPager(req) {
  return request({
    url: apiConfig.projectStatistics.api.searchPager.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
export function getProjectStapager(req) {
  return request({
    url: apiConfig.projectStatistics.api.detail.url.pager,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
export function projectUserPager(req) {
  return request({
    url: apiConfig.projectStatistics.api.detail.url.projectUserPager,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}

// 机构收益树结构数据
export function getAgentIncomTree(req, pager) {
  return request({
    url: apiConfig.projectStatistics.api.getAgentIncomTree.url,
    method: "post",
    data: {
      agentId: req.agentId,
      startTime: req.startTime,
      endTime: req.endTime,
      agentIds: req.agentIds,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 机构收益树结构数据
export function getAgentIncomTreePager(req, pager) {
  return request({
    url: apiConfig.projectStatistics.api.getAgentIncomTreePager.url,
    method: "post",
    data: {
      agentId: req.agentId,
      startTime: req.startTime,
      endTime: req.endTime,
      agentIds: req.agentIds,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 导出机构收益树
export function downloadAgentIncomeTree(req) {
  return request({
    url: apiConfig.projectStatistics.api.downloadAgentIncomeTree.url,
    method: "post",
    data: {
      agentId: req.agentId,
      startTime: req.startTime,
      endTime: req.endTime,
      agentIds: req.agentIds
    },
    responseType: "blob"
  });
}
